const delay = 1000;
const namespaces = {};

export default function quickClick(namespace) {
  const now = Date.now();
  const lastTime = namespaces[namespace];
  namespaces[namespace] = now;

  if (!lastTime) {
    return false;
  }

  return now - lastTime < delay;
}



// WEBPACK FOOTER //
// ./src/utils/quick-action.js